import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { HomeLayout } from "../../layouts";

import "./styles.css";

import Banner from "../../assets/MIKE0081.JPG";

function SawtiIlak2023() {
  return (
    <>
      <img
        className="banner"
        style={{ width: "100%", objectFit: "cover" }}
        src={Banner}
        alt="sawti ilak 2023 poster"
      />
      <Container className="mb-0 pb-2">
        <Row>
          <Col className="d-flex flex-column justify-center mt-3">
            <h5 style={{ fontWeight: 700 }}>
              Sawti Ilak 2023: A Night of Worship and Unity!
            </h5>
            <p>
              We are overjoyed to share with you the touching and motivational
              recap of the MEC (Middle East Center)-organized Sawti Ilak 2023
              event. It was an unforgettable night of worship, unity, and talent
              that left a blessed mark on our hearts.
            </p>
            <br />
          </Col>
        </Row>
        <Row className="mt-3">
          <h6 style={{ fontWeight: 700, color: "white" }}>
            Sawti Ilak 2023 Highlights:
          </h6>
        </Row>
        <p className="pt-2">
          Worship Night: The event kicked off with a powerful worship night
          where voices and hearts were lifted in unison, celebrating the
          boundless love and grace of our Savior.
        </p>
        <p className="pt-2">
          Churches United: Sawti Ilak was a testament to the strength of unity
          among churches. Congregations from various denominations came together
          to worship as one, fostering a sense of togetherness and harmony.
        </p>
        <p className="pt-2">
          Original Worship Songs: Bands took their creativity to new heights by
          composing and performing their own worship songs, adding a personal
          touch to the night's worship. The MEC Worship team also sang a medley
          featuring songs from previous Sawti Ilak events.
        </p>
        <p> Stay tuned as we will be uploading the songs soon!</p>
        <p className="pt-2">
          Trophy of Achievement: Each church band participating in Sawti Ilak
          2023 was awarded a prestigious disk trophy as a symbol of their
          dedication and commitment to worship through music.
        </p>
        <br />

        <h5 className="mt-3" style={{ fontWeight: 700 }}>
          Get Ready for Next Year:
        </h5>
        <p>
          As we bask in the afterglow of this remarkable event, we can't help
          but look ahead with excitement. Sawti Ilak 2024 promises to be even
          more exceptional, with new opportunities for growth, unity, and
          worship.
        </p>
        <br />
        <p style={{ fontWeight: 700 }}>
          Stay updated for new projects at MEC worship by following our social
          media platforms.
        </p>
        <br />
        <p>
          We praise God for making Sawti Ilak 2023 a resounding success.
          Together, we will continue to celebrate the power of music and unity
          in our faith communities.
        </p>
        <br />
      </Container>
    </>
  );
}

function Home() {
  return (
    <HomeLayout>
      <SawtiIlak2023 />
    </HomeLayout>
  );
}

export default Home;
